module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/q01_2_sp_d124337c3c851672b6eba983d38502ce.png";